import {curry, CurriedFunction3} from './function'

export const splitOnFirst = (pattern: string, str: string): [string, string] => {
  const index = str.indexOf(pattern)
  return [str.substring(0, index), str.substring(index + 1)]
}

export const kebabCase = (str: string): string =>
  str.toLowerCase().replace(/[\W_]+/g, '-')

export const replace = curry((
  pattern: RegExp,
  replacement: (match: string, index: number) => string,
  subject: string
): string =>
  subject.replace(pattern, replacement)
)

export const camelCase = replace(/(?:^\w|[A-Z]|\b\w|\W\w|\s+)/g, (match, index) => {
  if (+match === 0) {
    return ''
  }

  return (index === 0 ? match.toLowerCase() : match.toUpperCase()).replace(/\W+/, '')
})

export const padStart = curry((
  length: number,
  char: string,
  subject: string
): string =>
  subject.padStart(length, char)
)

const random = (from: number, to: number): number => {
  const variable = (to - from + 1) + from
  return Math.floor(Math.random() * variable)
}

export function randomId () {
  function transformTemplate (templateChar: string): string {
    return charToNumber(templateChar).toString(16)
  }

  function generateNumber (): number {
    return Math.random() * 16 | 0
  }

  function charToNumber (char: string): number {
    const randomNumber = generateNumber()
    return char === 'x' ? randomNumber : (randomNumber & 0x3 | 0x8)
  }

  const ID_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
  return ID_TEMPLATE.replace(/[xy]/g, transformTemplate)
}
